export const h = {
    "common": {
        "webSuffix": "- QIDI tech technologie",
        "email": "Boîte aux lettres",
        "password": "Mot de passe",
        "verificationCode": "Code de vérification",
        "username": "Nom d'utilisateur",
        "readAndAgree": "Je suis d'accord",
        "and": "Et",
        "userAgreement": "Accord utilisateur",
        "privacyPolicy": "Politique de confidentialité",
        "copy": "Tous droits réservés ©  2025 di réserve de propriété",
        "sendVerificationCode": "Envoyer le Code de vérification",
        "Sending": "En envoi",
        "tryAgainInSeconds": "Réessayez en secondes",
        "userNameRequired": "Veuillez entrer un nom d'utilisateur",
        "passwordInputLabel": "Veuillez entrer votre mot de passe",
        "checkPasswordInputLabel": "Veuillez entrer votre mot de passe de confirmation",
        "userEmailRequired": "Veuillez entrer une adresse mail",
        "userEmailInvalid": "Veuillez entrer une adresse e - mail correcte",
        "emailCodeRequired": "Veuillez entrer le Code de vérification",
        "newPasswordInputLabel": "Veuillez entrer un nouveau mot de passe",
        "confirmPasswordInputLabel": "Veuillez saisir à nouveau votre mot de passe",
        "passwordMismatchErrorLabel": "Deux entrées de mot de passe incohérentes",
        "agreementRequired": "Veuillez lire et accepter l'Accord",
        "tip": "Conseils",
        "tipAlreadyLogin": "Détecté que vous êtes déjà connecté sauter pour vous au Centre utilisateur",
        "tipWelcomeBack": "Bienvenue de retour ~",
        "tipDeleteAccountFail": "La suppression du compte a échoué, l'interface de suppression du compte est temporairement fermée",
        "pleaseAgreeFirst": "Veuillez d'abord accepter",
        "agree": "D'accord.",
        "refuse": "Refusé",
        "tipNeedLogin": "Veuillez vous connecter en premier",
        "tipChangePasswordSuccess": "Modifier votre mot de passe avec succès passer à la page de connexion pour vous",
        "tipGetUserInfoSuccess": "Accès à l'information réussi",
        "tipGetUserInfoFail": "L'accès à l'information a échoué",
        "tipLoginOut": "Se déconnecter du login",
        "delete": "Supprimer",
        "back": "Retour",
        "init": "Initialisation",

        "passwordInputLengthErrorLabel": "La longueur du mot de passe doit être comprise entre 6 et 20",
        "changePasswordFail": "Erreur dans le mot de passe original",
        "tipDeleteAccountSuccess": "Supprimer le compte avec succès",
        "emailCodeSentSuccess": "Le Code de vérification a été envoyé",
        "emailCodeSentFail": "Échec du Code de vérification",
        "emailLoginFail": "Le Code de vérification a expiré",
        "passwordLoginFail": "Login mot de passe incorrect",
        "editUserInfoSuccess": "Modification des informations utilisateur réussie",
        "registerSuccess": "Inscription réussie",
        "registerFail": "Enregistrement échoué",
        "registerEmailExistFail": "La boîte aux lettres existe déjà",

        "resMessageTip0": "Informations inconnues",
        "resMessageTip1": "Erreur de mot de passe",
        "resMessageTip2": "La longueur du mot de passe doit être comprise entre 6 et 20",
        "resMessageTip3": "Erreur de numéro de compte",
        "resMessageTip4": "Le Code de vérification a été envoyé",
        "resMessageTip5": "Échec du Code de vérification",
        "resMessageTip6": "Le Code de vérification a expiré",
        "resMessageTip7": "Erreur de mot de passe",
        "resMessageTip8": "Le mot de passe ne peut pas être identique à l'ancien",
        "resMessageTip9": "La boîte aux lettres existe déjà",
        "resMessageTip10": "Inscription réussie",
        "resMessageTip11": "Enregistrement échoué",
        "resMessageTip12": "Modification des informations utilisateur réussie",
        "resMessageTip13": "La modification des informations utilisateur a échoué",
        "resMessageTip14": "Obtenir le succès",
        "resMessageTip15": "Obtenir un échec",
        "resMessageTip16": "Modifier le mot de passe avec succès",
        "resMessageTip17": "La modification du mot de passe a échoué",
        "resMessageTip18": "Réinitialisation du mot de passe réussie",
        "resMessageTip19": "La Réinitialisation du mot de passe a échoué",
        "resMessageTip20": "Connexion réussie",
        "resMessageTip21": "La connexion a échoué",
        "resMessageTip22": "Supprimer le compte avec succès",
        "resMessageTip23": "La suppression du numéro de compte a échoué",
        "resMessageTip24": "Le Code de vérification est erroné",
        "noUserInfoError": "Erreur réseau, veuillez vous reconnecter"
    },
    "changePassword": {
        "newPassword": "Nouveau mot de passe"
    },
    "deleteUser": {
        "tipDeleteUser": "C'est dommage que vous partiez. Une fois votre numéro de compte supprimé, toutes vos données personnelles disparaissent définitivement et ne peuvent plus être récupérées.",
        "accountDeletionTerms": "Conditions de suppression du numéro de compte"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "Récupérer le mot de passe via la boîte mail",
        "confirmPassword": "Confirmer le mot de passe",
        "resettingPassword": "Réinitialiser le mot de passe",
        "resetting": "Réinitialisation"
    },
    "login": {
        "passwordLogin": "Mot de passe login",
        "verifyLogin": "Vérifier le login",
        "accountRegistration": "Enregistrement du numéro de compte",
        "forgotPassword": "Mot de passe oublié",
        "login": "Se connecter",
        "localLogin": "Connexion locale",
        "loginOut": "Déconnexion",
        "continueOnYourWay": "Continuer vers"
    },
    "register": {
        "registerAnAccount": "Numéro de compte enregistré",
        "register": "Enregistrement"
    },
    "userCenter": {
        "personalInformation": "Données personnelles",
        "modifyInformation": "Modifier les informations",
        "changePassword": "Modifier le mot de passe",
        "cancelAccount": "Numéro de compte annulé",
        "exitAccount": "Numéro de compte de sortie",
        "change": "Modifier",
        "maxCharLimitTip": "Le nom d'utilisateur ne peut pas dépasser 10 caractères chinois",
    },
    "policies": {
        "deleteAccountPrivacy": "Supprimer le contrat de numéro de compte",
        "agreement": "Utilisation du Protocole",
        "privacyPolicy": "Politique de confidentialité"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Choisissez votre pays ou région",
        "recommendedVisits": "Visite recommandée",
        "NorthAmerica": "Amérique du Nord",
        "Europe": "Europe",
        "Asia": "Asie",
        "Other": "Autres",
    }
}
export const aAndL ={
    "ar": {
        "Country": "Arabe",
        "Language": "Arabe"
    },
    "cs": {
        "Country": "Tchèque",
        "Language": "Tchèque"
    },
    "de": {
        "Country": "Allemagne",
        "Language": "Allemand"
    },
    "en": {
        "Country": "Royaume - Uni",
        "Language": "Anglais"
    },
    "es": {
        "Country": "Espagne",
        "Language": "Espagnol"
    },
    "fr": {
        "Country": "France",
        "Language": "Français"
    },
    "he": {
        "Country": "Israël",
        "Language": "Hébreu"
    },
    "hu": {
        "Country": "Hongrie",
        "Language": "Hongrois"
    },
    "it": {
        "Country": "Italie",
        "Language": "Italien"
    },
    "ja": {
        "Country": "Japon",
        "Language": "Japonais"
    },
    "ko": {
        "Country": "Corée du Sud",
        "Language": "Coréen"
    },
    "nl": {
        "Country": "Pays - Bas",
        "Language": "Néerlandais"
    },
    "pt": {
        "Country": "Portugal",
        "Language": "Portugais"
    },
    "pt_BR": {
        "Country": "Portugal (Brésil)",
        "Language": "Portugais (Brésil)"
    },
    "ru": {
        "Country": "Russie",
        "Language": "Russe"
    },
    "sv": {
        "Country": "Suède",
        "Language": "Suédois"
    },
    "tr": {
        "Country": "Turquie",
        "Language": "Turc"
    },
    "uk": {
        "Country": "Ukraine",
        "Language": "Ukrainien"
    },
    "zh": {
        "Country": "Chine continentale",
        "Language": "Chinois simplifié"
    },
    "zh_tw": {
        "Country": "Taïwan, Chine",
        "Language": "Chinois traditionnel"
    },
    "Canada": {
        "Country": "Au Canada",
        "Language": "Anglais"
    },
    "United_States": {
        "Country": "États - Unis",
        "Language": "Anglais"
    },
    "United_Kingdom": {
        "Country": "Royaume - Uni",
        "Language": "Anglais"
    },
    "EU_Countries": {
        "Country": "Pays de l'UE",
        "Language": "Anglais"
    },
    "Australia": {
        "Country": "Australie",
        "Language": "Anglais"
    },
    "globalzh": {
        "Country": "Dans le monde entier",
        "Language": "Chinois simplifié"
    },
    "globalen": {
        "Country": "Global",
        "Language": "Anglais"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/fr.js